import { useQuery } from '@tanstack/vue-query';
import Axios from 'axios';
import { computed } from 'vue';

export default function useWishListCheckQuery(products) {
  const queryKey = computed(() => ['wishlist-check', (products.value ?? []).join(',')]);
  const enabled = computed(() => (products.value?.length ?? 0) > 0);

  return useQuery({
    queryKey,
    queryFn: () => Axios.get('/api/wishlist/check', {
      params: { products: products.value },
    }),
    enabled,
    refetchOnWindowFocus: false,
  });
}
